import React, {ReactElement} from "react"
import TitleBar from "../../components/TitleBar/TitleBar"
import {MainSectionTable} from "../../containers/MainSection/MainSection"
import ManagedSolutionsIntentsTable from "../../components/ManagedSolutionsIntents/ManagedSolutionsIntentsTable"
import NewIntentModal from "../../components/ManagedSolutionsIntents/NewIntentModal"
import {usePaging} from "../../hooks/usePaging"
import {useAccessToken} from "../../services/auth"
import {findIntents, PaymentIntent} from "../../resources/intents"
import {AsyncResultComponent} from "../../containers/AsyncResult/AsyncResult"
import {DataTableActionHeader, DataTableCard, TablePending} from "../../components/DataTable/DataTable"
import {useQueryState} from "use-location-state"
import {useRefreshToken} from "../../hooks/useRefreshToken"
import {useModal} from "react-modal-hook"
import Icon from "../../components/Icon/Icon"
import {OkDocument} from "../../resources/common"

export function ManagedSolutionsIntentsPage(): ReactElement {
	const accessToken = useAccessToken()
	const limit = 40
	const [refreshToken, refresh] = useRefreshToken()

	const [sortBy, setSortBy] = useQueryState("rtl-intent--sort", "-createdAt")

	const [result, hasPrev, hasNext, prev, next, hasResults, reset] = usePaging(
		limit,
		(offset, limit) => findIntents({accessToken, offset, limit, sort: sortBy}),
		(x: OkDocument<PaymentIntent[]>) => x.data.length,
		[sortBy, refreshToken],
		"rtl-intent",
		true
	)

	const toggleSort = () => {
		setSortBy(sortBy === "-createdAt" ? "createdAt" : "-createdAt")
		reset(limit)
	}

	const [showModal, hideModal] = useModal(() => <NewIntentModal close={hideModal} refresh={refresh} />)

	return (
		<>
			<TitleBar title="Suggested Actions">
				<button className="button button-create" onClick={() => showModal()}>
					<Icon icon="interface-add-1" size={12} /> Create
				</button>
			</TitleBar>

			<MainSectionTable>
				<DataTableCard className="managed-solutions-intents-card">
					<DataTableActionHeader enableSticky={true} />
					<AsyncResultComponent asyncResult={result} pendingComponent={<TablePending numberOfRows={6} />}>
						{({value: intents}: {value: OkDocument<PaymentIntent[]>}) => (
							<ManagedSolutionsIntentsTable
								intents={intents.data}
								hasResults={hasResults}
								hasPrev={hasPrev}
								hasNext={hasNext}
								prev={prev}
								next={next}
								isUsingPaging={true}
								fullHeight={true}
								meta={intents.meta}
								sortBy={sortBy}
								sortFunction={toggleSort}
							/>
						)}
					</AsyncResultComponent>
				</DataTableCard>
			</MainSectionTable>
		</>
	)
}
